<div class="flex flex-wrap justify-between items-center gap-4 mt-4 pagination-container">
  <div class="text-sm text-gray-300 order-2 md:order-1">
    {{ 'PAGINATION.SHOWING' | translate }}
    <span class="font-medium">{{ startItem() }} - {{ endItem() }}</span>
    {{ 'PAGINATION.OF' | translate }}
    <span class="font-medium">{{ paginationState().totalItems }}</span>
    {{ 'PAGINATION.ITEMS' | translate }}
  </div>

  <div class="flex items-center justify-center gap-2 flex-1 order-1 md:order-2 min-w-0">
    @if (totalPages() > 1) {
      <app-button
        type="button"
        size="small"
        color="primary"
        (click)="onChangePagination(paginationState().currentPage - 1, paginationState().itemsPerPage)"
        [disabled]="paginationState().currentPage === 0 || paginationState().loading"
      >
        {{ 'PAGINATION.PREVIOUS' | translate }}
      </app-button>

      @if (displayMode() === 'full') {
        <div class="flex items-center gap-1">
          @for (item of visiblePageNumbers(); track $index) {
            @if (item === 'ellipsis') {
              <span class="px-2 text-neutral-500">…</span>
            } @else {
              <button
                type="button"
                class="min-w-[32px] h-8 px-2 rounded-md text-sm font-medium transition-colors
                {{ (paginationState().currentPage + 1) === item
                  ? 'bg-black text-white dark:bg-white dark:text-black'
                  : 'bg-neutral-100 dark:bg-neutral-700 hover:bg-neutral-200 dark:hover:bg-neutral-600 text-black dark:text-white'
                }}"
                [disabled]="paginationState().loading"
                (click)="goToPage(item)"
              >
                {{ item }}
              </button>
            }
          }
        </div>
      }

      @if (displayMode() === 'input') {
        <input
          type="number"
          min="1"
          [max]="totalPages()"
          [ngModel]="pageInputValue()"
          (ngModelChange)="pageInputValue.set($event)"
          (keydown.enter)="submitPageInput()"
          class="w-12 h-8 px-2 rounded-md text-sm font-medium text-center border border-neutral-300  dark:bg-neutral-950 dark:text-white focus:outline-none focus:ring-1 focus:ring-primary [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
          [disabled]="paginationState().loading || totalPages() <= 1"
          [attr.aria-label]="'PAGINATION.PAGE' | translate"
        />
        <span class="px-2 text-neutral-300 text-sm">/</span>
        <span class="px-1 text-neutral-100 text-sm">{{ totalPages() }}</span>
      }

      <app-button
        type="button"
        size="small"
        color="primary"
        (click)="onChangePagination(paginationState().currentPage + 1, paginationState().itemsPerPage)"
        [disabled]="(paginationState().currentPage + 1) * paginationState().itemsPerPage >= paginationState().totalItems || paginationState().loading"
      >
        {{ 'PAGINATION.NEXT' | translate }}
      </app-button>
    }
  </div>

  <div class="flex items-center space-x-2 order-3">
    <select
      #pageSize
      class="px-3 py-1 border rounded-md text-sm h-[30px] font-medium dark:bg-neutral-950 dark:text-white"
      [value]="paginationState().itemsPerPage"
      (change)="onChangePagination(paginationState().currentPage, +pageSize.value)"
      [disabled]="paginationState().loading"
    >
      @for (option of pageSizes; track option) {
        <option class="dark:bg-black" [value]="option" [selected]="option === paginationState().itemsPerPage">
          {{ option }}
        </option>
      }
    </select>
  </div>
</div>
